import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=bcdf431e&scoped=true"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"
import style0 from "./Installation.vue?vue&type=style&index=0&id=bcdf431e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdf431e",
  null
  
)

export default component.exports